// src/services/backgroundjobs/BackgroundJobService.ts

import backgroundJobApi from '../../api/backgroundjobs/backgroundJobApi';

const BackgroundJobService = {
  /**
   * Lista las tareas activas del usuario.
   */
  getActiveJobs: async () => {
    const response =
      await backgroundJobApi.fetchCustom('/active');

    return response.data;
  },

  /**
   * Lista las tareas recientes del usuario.
   */
  getRecentJobs: async () => {
    const response =
      await backgroundJobApi.fetchCustom('');

    return response.data;
  },

  /**
   * Obtiene el progreso de una tarea.
   */
  getProgress: async (uuid: string) => {
    const response =
      await backgroundJobApi.fetchCustom(`/${uuid}`);

    return response.data;
  },

  /**
   * Obtiene el detalle de una tarea.
   */
  getDetail: async (uuid: string) => {
    const response =
      await backgroundJobApi.fetchCustom(
        `/${uuid}/detail`
      );

    return response.data;
  },

  /**
   * Descarga el archivo generado.
   */
  download: async (
    uuid: string,
    fallbackName = 'archivo.zip',
    onProgress?: (progress: number | null) => void
  ): Promise<string> => {
    const result =
      await backgroundJobApi.downloadBlobGet(
        `/${uuid}/download`,
        fallbackName,
        onProgress
      );

    return result.fileName;
  },
};

export default BackgroundJobService;